// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disable-click[data-v-647eb2fb] {\n  pointer-events: none;\n  color: #ccc;\n  cursor: not-allowed;\n}", ""]);
// Exports
module.exports = exports;
